import { render, staticRenderFns } from "./MetaSendItem.vue?vue&type=template&id=6c360146&"
import script from "./MetaSendItem.vue?vue&type=script&lang=js&"
export * from "./MetaSendItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports